export class MelodyPatternStrategy {
  generate(ctx, chord, oct, baseDegree, rand, bpb, genre) {
    if (genre === 'jazz') return this._genJazzMelody(ctx, chord, oct, baseDegree, rand, bpb);
    if (genre === 'ambient') return this._genAmbientMelody(ctx, chord, oct, baseDegree, rand, bpb);
    if (genre === 'breakcore') return this._genBreakcoreMelody(ctx, chord, oct, baseDegree, rand, bpb);
    return this._genMelody(ctx, chord, oct, baseDegree, rand, bpb);
  }

  _genMelody(ctx, chord, oct, baseDegree, rand, bpb = 4) {
    const pattern = [];
    const melOct = oct + 1;
    const scaleLen = ctx.scale.length;
    const chordDegrees = ctx.chordToScaleDegrees(chord);
    const numNotes = 4 + Math.floor(rand() * 3);
    let currentDeg = chordDegrees.length > 0 ? chordDegrees[Math.floor(rand() * chordDegrees.length)] : baseDegree;
    const template = ctx.buildMelodyRhythm(rand, bpb, numNotes);
    for (let i = 0; i < Math.min(numNotes, template.length); i++) {
      const beat = template[i];
      const isStrong = beat === 0 || beat === Math.floor(bpb / 2);
      if (isStrong && rand() < 0.75 && chordDegrees.length > 0) {
        let nearest = chordDegrees[0];
        let nearDist = 999;
        for (const cd of chordDegrees) {
          const d = Math.abs(currentDeg - cd);
          if (d < nearDist) { nearest = cd; nearDist = d; }
        }
        currentDeg = nearest;
      } else {
        const step = rand() < 0.75 ? (rand() < 0.5 ? 1 : -1) : (rand() < 0.5 ? 2 : -2);
        currentDeg += step;
      }
      currentDeg = Math.max(0, Math.min(currentDeg, scaleLen * 2 - 1));
      pattern.push({ beat, note: ctx.noteFromDegree(currentDeg, melOct), duration: 0.18 + rand() * 0.32 });
    }
    if (pattern.length > 0 && chordDegrees.length > 0) {
      const lastBeat = pattern[pattern.length - 1].beat;
      if (lastBeat < bpb - 0.25) {
        pattern.push({ beat: Math.min(lastBeat + 0.75, bpb - 0.25), note: ctx.noteFromDegree(chordDegrees[0], melOct), duration: 0.4 + rand() * 0.3 });
      }
    }
    return pattern;
  }

  _genJazzMelody(ctx, chord, oct, baseDegree, rand, bpb = 4) {
    const pattern = [];
    const melOct = oct + 1;
    const scaleLen = ctx.scale.length;
    const chordDegrees = ctx.chordToScaleDegrees(chord);
    const numNotes = 5 + Math.floor(rand() * 4);
    let currentDeg = chordDegrees.length > 0 ? chordDegrees[Math.floor(rand() * chordDegrees.length)] : baseDegree;
    const template = ctx.buildMelodyRhythm(rand, bpb, numNotes);
    for (let i = 0; i < Math.min(numNotes, template.length); i++) {
      const beat = template[i];
      const stepFirst = rand() < 0.3;
      if (stepFirst) currentDeg += rand() < 0.5 ? 1 : -1;
      else if (rand() < 0.3) currentDeg += (rand() < 0.5 ? 1 : -1) * [2, 3, 4][Math.floor(rand() * 3)];
      else currentDeg += rand() < 0.5 ? 1 : -1;
      if ((beat === 0 || beat === Math.floor(bpb / 2)) && rand() < 0.6 && chordDegrees.length > 0) {
        currentDeg = chordDegrees[Math.floor(rand() * chordDegrees.length)];
      }
      currentDeg = Math.max(-2, Math.min(currentDeg, scaleLen * 2 + 2));
      pattern.push({ beat, note: ctx.noteFromDegree(currentDeg, melOct), duration: 0.12 + rand() * 0.35 });
    }
    return pattern;
  }

  _genAmbientMelody(ctx, chord, oct, baseDegree, rand, bpb = 4) {
    const pattern = [];
    const melOct = oct + 1;
    const chordDegrees = ctx.chordToScaleDegrees(chord);
    const numNotes = 1 + Math.floor(rand() * 3);
    for (let i = 0; i < numNotes; i++) {
      const deg = chordDegrees.length > 0 ? chordDegrees[Math.floor(rand() * chordDegrees.length)] : baseDegree + Math.floor(rand() * 5);
      pattern.push({ beat: rand() * bpb, note: ctx.noteFromDegree(deg, melOct), duration: 0.8 + rand() * 2.0 });
    }
    return pattern;
  }

  _genBreakcoreMelody(ctx, chord, oct, baseDegree, rand, bpb = 4) {
    const pattern = [];
    const melOct = oct + 1;
    const scaleLen = ctx.scale.length;
    const numNotes = 6 + Math.floor(rand() * 8);
    let currentDeg = baseDegree;
    for (let i = 0; i < numNotes; i++) {
      const beat = (i / numNotes) * bpb + (rand() - 0.5) * 0.15;
      if (rand() < 0.4) currentDeg = Math.floor(rand() * scaleLen * 2);
      else currentDeg += Math.floor(rand() * 5) - 2;
      currentDeg = Math.max(0, Math.min(currentDeg, scaleLen * 2 - 1));
      pattern.push({ beat: Math.max(0, Math.min(beat, bpb - 0.05)), note: ctx.noteFromDegree(currentDeg, melOct + (rand() < 0.2 ? 1 : 0)), duration: 0.03 + rand() * 0.12 });
    }
    return pattern;
  }
}
